export default {
  base: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/layouts/base.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/layouts/default.vue").then(m => m.default || m),
  general: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/layouts/general.vue").then(m => m.default || m),
  "shared-view": () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/layouts/shared-view.vue").then(m => m.default || m)
}